var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modalRoulette",
      staticClass: "modal fade",
      attrs: {
        id: "modalRoulette",
        "hide-footer": "",
        "hide-header": "",
        centered: "",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "modalRouletteTitle",
        "aria-hidden": "true"
      }
    },
    [
      !_vm.isDisabled
        ? _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.closeModal()
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "modal-body o-modalRoulette" }, [
        _c("div", { staticClass: "m-modalRoulette__footer d-flex" }, [
          _c("section", { staticClass: "section" }, [
            _c("div", { staticClass: "rouletteContainer" }, [
              _c("h2", { staticClass: "m-modalRoulette__name text-center" }, [
                _vm._v("Vyskúšaj šťastie")
              ]),
              _vm._v(" "),
              _c("div", [
                _c("img", {
                  attrs: { src: "assets/img/ruleta/backgroundRuleta.png" }
                }),
                _vm._v(" "),
                _c("canvas", {
                  ref: "ruletaCanvas",
                  attrs: { width: "516", height: "549" }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: "assets/img/ruleta/sipkaRuleta.png" }
                })
              ])
            ]),
            _vm._v(" "),
            _c(
              "form",
              [
                _vm.responseText != ""
                  ? _c(
                      "div",
                      {
                        class: "alert alert-" + _vm.responseType,
                        attrs: { role: "alert" }
                      },
                      [
                        _c("span", { class: "icon --" + _vm.responseType }),
                        _vm._v(
                          _vm._s(_vm.responseText) + "\n                    "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.reward_text != ""
                  ? [
                      _c("span", [
                        _c("h3", { staticClass: "mb-0 greenColor" }, [
                          _vm._v("Dokrútené!")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "rouletteWinText" }, [
                          _vm._v(_vm._s(_vm.reward_text) + " "),
                          _c("span", { staticClass: "prize" }, [
                            _vm._v(
                              _vm._s(_vm.reward_nazov) +
                                " " +
                                _vm._s(_vm.reward_kusov)
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn --primary",
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [_vm._v("POKRAČOVAŤ")]
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isDisabled
                  ? _c(
                      "button",
                      {
                        staticClass: "btn --primary",
                        on: { click: _vm.spinRuleta }
                      },
                      [_vm._v("ROZTOČIŤ KOLESO")]
                    )
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }